export const writeWarning = () => {
    // eslint-disable-next-line no-console
    console.log(
        `%cThis is a warning!
Please do not use any JavaScript using copy/paste
from elsewhere on the web or any person.`,
        'color:white;font-size: 1.8em;background:red'
    );
};
